<template>
  <div class="home-wrapper">
    <div class="box">
      <div class="exhibition">
        新国际展区
      </div>
      <div class="title-box">
        <div class="title">
          <div class="lf">
            <div class="txt">观众报名</div>
            <div class="tip">（此页面所有选项均为必填）</div>
          </div>
          <!-- <el-button
            type="primary"
            class="btn"
            size="medium"
            round
            @click="agent"
            >代报名</el-button
          > -->
          <el-button
            type="primary"
            class="btn"
            size="medium"
            round
            @click="agent"
            >协助注册</el-button
          >
        </div>
        <!-- <div class="msg">
          由于突发疫情，AWE2022没能如期举办，让人深感惋惜，给各位观众造成的不便，我们深表歉意。对困难环境下一直给予我们关注和支持的观众心存感激！我们将全力以赴办好
          AWE2023！
          （根据要求已经注册AWE2022的观众需要重新注册AWE2023，感谢您的配合）
        </div> -->
      </div>
      <el-form
        ref="formA"
        :model="formA"
        :rules="rules"
        inline
        hide-required-asterisk
        label-width="373px"
        label-position="top"
        class="form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="姓名" class="item" prop="name">
              <el-input
                class="ipt"
                :disabled="isEdit"
                v-model="formA.name"
                placeholder="请填写您的姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件类型" class="item" prop="country">
              <el-select
                class="ipt"
                :disabled="isEdit"
                v-model="formA.cardType"
                placeholder="请选择证件类型"
                @change="cardChange"
              >
                <el-option
                  v-for="item in cardList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件号码" class="item" prop="idcard">
              <el-input
                class="ipt"
                :disabled="isEdit"
                v-model="formA.idcard"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="国家" class="item" prop="country">
              <el-select
                class="ipt"
                filterable
                v-model="formA.country"
                placeholder="请选择活动区域"
                @change="countryChange"
              >
                <el-option
                  v-for="item in clist"
                  :key="item.id"
                  :label="item.name_zh"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="省市区"
              class="item"
              prop="city"
              v-show="formA.country == 44"
            >
              <el-cascader
                class="ipt"
                v-model="formA.area"
                :options="cityList"
                filterable
                placeholder="请选择省市区"
                :props="{ value: 'id', label: 'name', children: 'child' }"
                @change="cityChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="从何渠道了解AWE（可多选）"
              class="item"
              prop="channel"
            >
              <el-select
                class="ipt"
                v-model="formA.channel"
                placeholder="请选择渠道"
                multiple
                collapse-tags
                @change="channelChange"
              >
                <!-- <el-option label="区域一" value="shanghai"></el-option> -->
                <el-option
                  v-for="item in findChannel"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="其他渠道"
              class="item2"
              prop="other"
              v-show="isOther != -1"
            >
              <el-input class="ipt2" v-model="formA.other"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份类别" class="item" prop="type">
              <el-select
                class="ipt"
                v-model="formA.type"
                placeholder="请选择身份类别"
                @change="statusChange"
              >
                <el-option label="专业观众" value="2"></el-option>
                <el-option label="消费者" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              label="主要关注品类（可多选）"
              class="item"
              v-show="formA.type == 1"
              prop="product"
            >
              <el-select
                class="ipt"
                v-model="formA.product"
                placeholder="请选择关注品类"
                multiple
                collapse-tags
                @change="productChange"
              >
                <!-- <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option> -->
                <el-option
                  v-for="item in productClass"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="公司"
              class="item"
              v-show="formA.type == 2"
              prop="company_name"
            >
              <el-autocomplete
                class="ipt"
                v-model="formA.company_name"
                :fetch-suggestions="querySearch"
                placeholder="请输入公司名称"
                @select="handleSelect"
                clearable
              ></el-autocomplete>
              <!-- <el-input class="ipt" v-model="formA.company_name"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-show="formA.type == 2" label="邮箱" class="item" prop="email">
              <el-input class="ipt" v-model="formA.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="部门"
              class="item"
              v-show="formA.type == 2"
              prop="department"
            >
              <el-input class="ipt" v-model="formA.department"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="职务"
              class="item"
              v-show="formA.type == 2"
              prop="job"
            >
              <el-input class="ipt" v-model="formA.job"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="岗位类别"
              class="item"
              v-show="formA.type == 2"
              prop="jobLevel"
            >
              <el-select
                class="ipt"
                v-model="formA.level"
                placeholder="请选择岗位类别"
              >
                <el-option
                  v-for="item in jobLevel"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="您所属的行业类别（可多选）"
              class="item1"
              v-show="formA.type == 2"
              prop="trade"
            >
              <el-cascader
                v-if="showlist"
                class="ipt1"
                v-model="tag"
                :options="industry"
                collapse-tags
                clearable
                placeholder="请选择您所属的行业类别"
                :props="{
                  emitPath: true,
                  multiple: true,
                  value: 'id',
                  label: 'name',
                  children: 'child',
                  checkStrictly: true
                }"
                @change="tradeChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item
          label="性别"
          class="item"
          v-show="formA.type == 1"
          prop="sex"
        >
          <el-select class="ipt" v-model="formA.sex" placeholder="请选择性别">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="年龄"
          class="item"
          v-show="formA.type == 1"
          prop="age"
        >
          <el-input class="ipt" v-model="formA.age"></el-input>
        </el-form-item> -->
        

        
        
        <!-- <el-form-item
          label="详细地址"
          class="item"
          prop="address"
          v-show="formA.type == 2"
        >
          <el-input
            type="textarea"
            autosize
            class="ipt"
            placeholder=""
            v-model="formA.address"
          ></el-input>
        </el-form-item> -->
        
        
        
        
      </el-form>
      <div class="btm">
        <el-button
          class="btn"
          type="primary"
          @click="save('formA')"
          :loading="submitLoading"
          >{{ is_reservation == 1 ? '提交报名，预约入场时间' : '提交报名' }}</el-button
        >
      </div>
      <div class="btm-pri">
        <el-checkbox v-model="checked"></el-checkbox>
				<span>同意并接受</span>
				<span style="color:#F08200;cursor: pointer;" @click="goPrivacy">《隐私政策》</span>
				<span style="color:#F08200;cursor: pointer;" @click="goSafety">《安全须知》</span>
			</div>
      <el-dialog
        :close-on-click-modal="close"
        :close-on-press-escape="close"
        :show-close="close"
        :visible.sync="pop"
        width="420px"
      >
        <el-form label-width="373px" label-position="top" class="pop">
          <el-form-item label="手机号码" class="mobile">
            <el-input class="ipt" v-model="formA.mobile">
              <el-select
                style="width: 130px"
                v-model="phonecode"
                slot="prepend"
                placeholder="请选择"
                @change="phoneCodeChange"
              >
                <el-option
                  v-for="item in clist"
                  :key="item.id"
                  :label="item.name_zh + '(+' + item.phonecode + ')'"
                  :value="item.phonecode"
                ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码" class="code">
            <el-input class="ipt" v-model="formA.code"></el-input>
            <el-button
              class="codebtn"
              type="primary"
              plain
              round
              @click="send"
              :disabled="loading"
              >获取验证码<span v-show="loading">（{{ ss }}s）</span></el-button
            >
          </el-form-item>
        </el-form>
        <el-button type="primary" class="popbtn" round @click="mobileSubmit"
          >确认</el-button
        >
      </el-dialog>

      <el-dialog
        :close-on-click-modal="close1"
        :close-on-press-escape="close1"
        :show-close="close1"
        :visible.sync="pop1"
        width="420px"
      >
        <div
          class="imgs"
          style="height: 400px; overflow: scroll; margin-bottom: 10px"
        >
          <img
            class="img"
            style="width: 100%"
            src="https://aweqn.zhiandexpo.com/txt.png"
            alt=""
          />
        </div>
        <el-button type="primary" class="popbtn" round @click="got"
          >我知道了</el-button
        >
      </el-dialog>

      <el-dialog
        :close-on-click-modal="close2"
        :close-on-press-escape="close2"
        :show-close="close2"
        :visible.sync="pop2"
        width="628px"
      >
        <div class="title">
          请选择您的入场时间
          <!-- <span class="stitle">（*蓝色加粗数字为可预约余量）</span> -->
        </div>
        <div class="timeList">
          <div v-for="(item, index) in keyList" :key="index" class="item">
            <div class="time">
              {{ item.split("-")[1] + "月" + item.split("-")[2] + "日" }}
            </div>
            <div class="checkBox">
              <div
                v-for="(itm, idx) in dateList[item]"
                :key="idx"
                class="checkItem"
                :class="ids.find((e) => e == itm.id) ? 'checked' : ''"
                @click="clickId(item, idx)"
              >
                <div class="item-top">
                  <!-- <div class="code">
                  {{ itm.code }}
                </div> -->
                  <div class="sd">
                    {{ itm.time == 1 ? "上午" : "下午" }}
                  </div>
                </div>
                <!-- <div class="item-mid">
                {{ itm.time == 1 ? "8:00-12:00" : "13:00-17:00" }}
              </div>
              <div class="item-btm">
                {{ itm.left_count }}
              </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <div class="submit" @click="submit">确认</div>
          <!-- <div class="cancel" @click="cancel">暂不选择</div> -->
        </div>
      </el-dialog>
    
      <div v-if="isShowMask" class="mask-box">
        <div class="maskTips">
          <!-- AWE2025已圆满落幕，明年见 -->
          <!-- 展会已结束，敬请期待！ -->
          <!-- 注册已停止，明年见 -->
          感谢关注AWE2027，展会观众报名已停止，我们明年见！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  city,
  customerApplySelectOption,
  tag,
  countryList,
  customerApply,
  sendMobile,
  mobileCodeAuth,
  customerApplyResult,
  getEnterTime,
  checkEnterTime,
  userReservation,
  search
} from "../../api/data";
import { JSEncrypt } from 'encryptlong'
export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写您的手机号码"));
      } else {
        if (!/(^1\d{10}$)/.test(this.formA.mobile) && this.phonecode == 86) {
          callback(new Error("手机号码格式错误"));
        }
        callback();
      }
    };

    var validateCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写您的证件号码"));
      } else {
        if (
          !/(^[0-9a-zA-Z]{18}$)/.test(this.formA.idcard) &&
          this.formA.cardType == 1
        ) {
          callback(new Error("证件号码格式错误"));
        }
        callback();
      }
    };

    var validateOther = (rule, value, callback) => {
      //console.log(value)
      if (value == undefined && this.isOther != -1) {
        callback(new Error("请填写您的了解渠道"));
      } else {
        callback();
      }
    };
    var validate = (rule, value, callback) => {
      // console.log(value)
      if (value === "" && this.formA.type == 1) {
        callback(new Error("此项为必填项"));
      } else {
        callback();
      }
    };
    var validate2 = (rule, value, callback) => {
      // console.log(value)
      if (value === "" && this.formA.type == 2) {
        callback(new Error("此项为必填项"));
      } else {
        callback();
      }
    };
    var validateArr = (rule, value, callback) => {
      if (value.length == 0 && this.formA.type == 1) {
        callback(new Error("请至少选择一个品类"));
      } else {
        callback();
      }
    };
    return {
      isEdit: false,
      showlist: false,
      pop: true,
      pop1: false,
      pop2: false,
      submitLoading: false,
      close: false,
      close1: false,
      close2: false,
      customerApplyId: 0,
      apply_type: 0,
      formA: {
        name: "",
        mobile: "",
        cardType: 1,
        idcard: "",
        email: "",
        country: 44,
        area: [0, 0, 0],
        code: "",
        address: "",
        type: "",
        channel: [],
        product: [],
        level: "",
        company_name: "",
        job: "",
        department: "",
        sex: "1",
        age: "",
        other: "",
      },
      clist: [],
      // area:[0,0,0],
      cityList: [],
      cardList: [],
      industry: [],
      phonecode: 86,
      ss: "",
      productClass: [],
      findChannel: [],
      jobLevel: [],
      tag: [],
      isOther: -1,
      country_name: "中国",
      province_name: "",
      city_name: "",
      district_name: "",
      trade_class: [],
      channel_id: 0,
      authTime: "",
      loading: false,
      rules: {
        name: [
          { required: true, message: "请填写您的姓名", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, validator: validateMobile, trigger: "blur" },
        ],
        idcard: [{ required: true, validator: validateCard, trigger: "blur" }],
        email: [
          { required: true, validator: validate2, trigger: "blur" },
          // {
          //   type: "email",
          //   message: "请输入正确的邮箱地址",
          //   trigger: ["blur", "change"],
          // },
        ],
        channel: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个渠道",
            trigger: "change",
          },
        ],
        type: [{ required: true, message: "请选择身份", trigger: "change" }],
        other: [{ required: true, validator: validateOther, trigger: "blur" }],
        age: [{ required: false, validator: validate, trigger: "blur" }],
        product: [
          { required: true, validator: validateArr, trigger: "change" },
        ],
        company_name: [
          { required: true, validator: validate2, trigger: "blur" },
        ],
        address: [{ required: false, validator: validate2, trigger: "blur" }],
        department: [{ required: true, validator: validate2, trigger: "blur" }],
        job: [{ required: true, validator: validate2, trigger: "blur" }],
        jobLevel: [{ required: true, validator: validate2, trigger: "blur" }],
      },
      dateList: [],
      keyList: [],
      ids: [],
      timeList: [],
      is_reservation: 0,
      isShowMask: false,
      checked: true,
      is_edit: false,
      publicKey: `-----BEGIN PUBLIC KEY-----
      MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvK2sPKZ1jfc7SX2A8SUl
      VoRKpgjOeBMFD6WY4uDX1uNz/l4Kjk4S7TeBelP09K6uP3WnmfjV8maWy8jX6V+i
      Ixtlnk63/OnzxnacGpmIKZIop806XpL9CXOnu4552MawCUHquLpmYciB84qxM01R
      DecX+Vodgo53IWSXpDYK6ION74UQ97iLMW/uPI2HpQUxmUEBYaHmFZynDPFZiT7k
      mWGsqdVN7pxF/yHEIQ6Nf2HFK5Yx1Z54/99M94uovl8J5kD+DZdSJWjU3CwWQnYC
      L/PylVq00puTIDt5mo6SDQzV5ZvoPTd3B4K3IUYCHs7mA+p/eysS/k8DQvsN+Jk8
      yQIDAQAB
      -----END PUBLIC KEY-----`,
      PRIVATE_KEY: `-----BEGIN PRIVATE KEY-----
      MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC8raw8pnWN9ztJ
      fYDxJSVWhEqmCM54EwUPpZji4NfW43P+XgqOThLtN4F6U/T0rq4/daeZ+NXyZpbL
      yNfpX6IjG2WeTrf86fPGdpwamYgpkiinzTpekv0Jc6e7jnnYxrAJQeq4umZhyIHz
      irEzTVEN5xf5Wh2CjnchZJekNgrog43vhRD3uIsxb+48jYelBTGZQQFhoeYVnKcM
      8VmJPuSZYayp1U3unEX/IcQhDo1/YcUrljHVnnj/30z3i6i+XwnmQP4Nl1IlaNTc
      LBZCdgIv8/KVWrTSm5MgO3majpINDNXlm+g9N3cHgrchRgIezuYD6n97KxL+TwNC
      +w34mTzJAgMBAAECggEAN7pgPgW4gPb+BuXP2OnszlICrmm5ehO8EfQKZTCd77V8
      xCvImGGNC42ya4wytLaHduzsVPj/UDpm3cfzpdV+UTo9WHXNuCDtxLexwdWJNyYZ
      Zf6i994YaNtFNouNh66fvgw/JNLBfK45W9KiJhH3F9Ei7p5kSvSDUVShyXnA3Q3E
      X00Qv60QN0e1a+qckq+5ZxTh2OOakplH5Ux5x9xYPlIKDxe734uNp+ql4VZ8yJ9o
      0jZS23HkPB7E4rzo7AsQNEHtm72vKmrBLU63h8sGHg7hM9U8khLkLFjSEz9aO+OJ
      fDaqSScexPYPG2yaQ2uymszhRgpaAl+xTNql038okQKBgQDeRZVbc+5XiD7nRYij
      YpNU0DyVqfxiIQ7LpFY8ZJ3UGNiDVrv0e8vHW0kLtn4VbEHNw3rwgftLilMpv2sc
      MTIOUnL2lYYBC5hU2mTnVsmwkEhv1xmx68P9B+zYFUHAdqj3DGdGQ0SnukZVfLsN
      Rjxd2CPutR6QdSkxCUVhnxhmpQKBgQDZTxz6a+T4lFYdVWuKAcUI0+J1nOLSQksy
      EMyJCv9AvSE+/7rsCGYfMAeREk7KiEVjSh9/4on2HJF7AFiTT2aq8GtHSPFCms0A
      L0Ysd5n9ave199gGQb74kQo85w4V04UdGkxJNhddf3RFKZrzJyFqoe+x4/uAbF+o
      xTxxMQIIVQKBgQDcOgmAMV+HruDUeNqnN7ZOpHxCtcfw2lw0fUFMWUzfpzZu+3MD
      C92eSt4XEtveEgMpAnQ+9CqucAFyLczMhBnaguqRUxkQ1BI8kJ7FcAIqROrglTlK
      RhVMEZwjhPw+29MR5GI3BdNydGfXr9wNjPem686+Zwo/izYi9dKepOmiWQKBgFO2
      7YPvUrsMcgxE3vPAcMZQ0fnbIWo8jblQzWqx6NlowskBPWI2bhjvqMqTUfUmAA0a
      /f2HKPy9zrGi1XySZwvNKJbCm+a7ueOrUo5I2PLOZXUdcIQgidA6F8aUgFGaNbqb
      ae3+P4wOUJ1gRMgNOAtbLPrLyBSWK1fZ+8njRlQtAoGBAJgIfpFKJEmDhUFBROzs
      WQ/toReWTEg1ts6XFRr4PSI0KfHlr0YcsGlNiyRqpHv44lgagA64eKI54Pu95m0u
      aKmjNRZSzC/Hd4QfAqhtS0G56baxRR7T7qV5/BWB40Cd9XJU/iY4tQTLK3ivYSiU
      5efxcbWYop6JG+X8XlHpH479
      -----END PRIVATE KEY-----
      `
    };
  },
  mounted() {
    // 当前时间
    // let nowDay = new Date()
    // // 到期时间
    // let fDay = new Date("2025/3/23 12:00:00")
    // if (nowDay.valueOf() > fDay.valueOf()) {
    //   // 展会结束
    //   this.isShowMask = true
    // }
    this.getList();
    this.getCity();
    this.countryList();
    this.getTag();
    this.getTime();
    if (this.$route.query.id) {
      this.pop = true
      this.is_edit = true
      this.customerApplyId = this.$route.query.id
      // this.getInfo()
    }
    // this.getInfo()
  },
  methods: {
    /**
     * 核心联想函数
     * @param {string} queryString - 用户输入的字符串
     * @param {function} callback - 用于返回结果的回调函数
     */
    querySearch(queryString, callback) {
      // 关键：只有输入长度 >= 6 时才进行联想
      if (queryString.length < 6) {
        return callback([]);
      }
      // 对公司列表进行过滤，不区分大小写
      search({ keyword: queryString }).then(res => {
        if (res.code === 0) {
          let result = []
          console.log(res.data)
          res.data.map(item => {
            result.push({ value: item })
          })
          callback(result)
        }
      })
    },

    /**
     * 用户选择了某个联想项时触发
     * @param {string} item - 用户选择的公司名
     */
    handleSelect(item) {
      this.formA.company_name = item.value
    },
    getTime() {
      getEnterTime().then((res) => {
        if (res.code == 0) {
          this.dateList = res.data.reduce(
            (r, x) => ((r[x.date] || (r[x.date] = [])).push(x), r),
            {}
          );
          var key = [];
          res.data.map((item) => {
            key.push(item.date);
          });
          for (var i = 0; i < key.length; i++) {
            if (this.keyList.indexOf(key[i]) === -1) {
              this.keyList.push(key[i]);
            }
          }
        }
      });
    },
    getUserTime() {
      userReservation({mobile: this.formA.mobile}).then(res => {
        if(res.code == 0) {
          this.ids = []
          this.timeList = res.data

          res.data.map(item => {
            this.ids.push(item.id)
          })
        }
      })
    },
    clickId(item, idx) {
      this.ids.indexOf(this.dateList[item][idx].id)
      if (this.ids.indexOf(this.dateList[item][idx].id) > -1) {
        this.ids.splice(this.ids.indexOf(this.dateList[item][idx].id), 1)
      } else {
        this.ids.push(this.dateList[item][idx].id)
      }
    },
    agent() {
      if (this.customerApplyId > 0) {
        this.$router.push({
          name: "agent",
          query: { mobile: this.formA.mobile, is_reservation: this.is_reservation },
        });
      } else {
        this.$message.error("请您先完成观众报名");
      }
    },

    cardChange() {
      // this.card_idx = e.target.value
      // console.log(e.target.value)
    },
    mobileSubmit() {
      if (this.formA.mobile == '') {
        this.$message.error("请填写您的手机号码")
      } else if (this.phonecode == 86 && !/^1[3-9]\d{9}$/.test(this.formA.mobile)) {
        this.$message.error("手机号码格式错误")
      } else {
        mobileCodeAuth({
          mobile: this.formA.mobile,
          mobile_code: this.formA.code,
          apply_origin: 2,
        }).then((res) => {
          if (res.code == 0) {
            this.customerApplyId = res.data.customerApplyId;
            this.is_reservation = res.data.is_reservation
            if (res.data.is_apply == 1) {
              this.getInfo();
              if (!this.is_edit) {
                this.$router.push({
                  name: "done",
                  query: {
                    id: res.data.customerApplyId,
                    apply_type: 1,
                    mobile: this.formA.mobile,
                    email: this.formA.email
                  },
                });
              }
            } else if (res.data.replace_apply != "") {
              // 当前时间
              let nowDay = new Date()
              // 到期时间
              // 换届：AWE2026 会期 3.12-15 -> AWE2027 会期 3.17-20，旧值 2026/3/15 12:00:00
              let fDay = new Date("2027/3/20 12:00:00")
              if (nowDay.valueOf() > fDay.valueOf()) {
                // 展会结束
                this.isShowMask = true
              } else {
                this.formA.name = res.data.replace_apply.name;
                this.phonecode = res.data.replace_apply.phonecode;
                this.formA.mobile = res.data.replace_apply.mobile;
                this.formA.idcard = res.data.replace_apply.IDcard;
                this.formA.cardType = res.data.replace_apply.IDcard_type;
                this.formA.type = res.data.replace_apply.type + "";
              }
            } else {
              // 当前时间
              let nowDay = new Date()
              // 到期时间
              // 换届：AWE2026 会期 3.12-15 -> AWE2027 会期 3.17-20，旧值 2026/3/15 12:00:00
              let fDay = new Date("2027/3/20 12:00:00")
              if (nowDay.valueOf() > fDay.valueOf()) {
                // 展会结束
                this.isShowMask = true
              }
            }
            this.pop = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      
    },
    getInfo() {
      customerApplyResult({
        customerApplyId: this.customerApplyId,
      }).then((res) => {
        if (res.code == 0) {
          this.isEdit = true;
          let info = res.data.apply_info;
          this.is_reservation = res.data.is_reservation

          console.log(info.province_id);
          this.formA.name = info.name;
          this.phonecode = info.phonecode;
          this.formA.mobile = info.mobile;
          this.formA.idcard = info.IDcard;
          this.formA.cardType = info.IDcard_type;
          this.formA.email = info.email;
          this.formA.country = info.country_id;
          this.country_name = info.country_name;
          this.formA.area = info.district_id == 0 ? [info.province_id, info.city_id] : [info.province_id, info.city_id, info.district_id];
          // this.formA.area[0] = info.province_id
          this.province_name = info.province_name;
          // this.formA.area[1] = info.city_id
          this.city_name = info.city_name;
          // this.formA.area[2] = info.district_id
          this.district_name = info.district_name;
          this.formA.address = info.address;
          let arr = [];
          for (let item of info.find_channel) {
            // item = Number(item)
            arr.push(Number(item));
          }
          this.formA.channel = arr;
          // console.log(this.formA.channel)
          this.formA.other = info.other;
          //消费者
          this.formA.type = info.type + "";
          this.formA.sex = info.sex + "";
          this.formA.age = info.age;
          this.formA.product = info.product_class;
          let arr1 = [];
          for (let item of info.product_class) {
            // item = Number(item)
            arr1.push(Number(item));
          }
          this.formA.product = arr1;
          //专业观众
          // booth_area,
          this.formA.company_name = info.company_name;
          this.formA.department = info.department;
          this.formA.job = info.job;
          this.formA.level = info.job_level;
          this.trade_class = info.trade_class;
          for (let item of info.trade_class) {
            let arr = [];
            if (item.grandparent_id != null &&  item.parent_id != null) {
              arr.push(item.grandparent_id, item.parent_id);
            }
            if (item.grandparent_id != null && item.parent_id == null) {
              arr.push(item.grandparent_id);
            }
            // if (item.id != null) {
            //   arr.push(item.id);
            // }
            this.tag.push(arr);
          }
          this.tradeChange(this.tag)
          this.showlist = true;

          console.log(this.tag);
        }
      });
    },
    send() {
      if (this.formA.mobile == "") {
        this.$message.error("请填写您的手机号码");
      } else if (
        !/(^1\d{10}$)/.test(this.formA.mobile) &&
        this.phonecode == 86
      ) {
        this.$message.error("手机号码格式错误");
      } else {
        var date = new Date().getTime()
        const encryptor = new JSEncrypt()
        encryptor.setPublicKey(this.publicKey)
        encryptor.setPublicKey(this.PRIVATE_KEY)
        const encrypted = encryptor.encryptLong(String(date))
        sendMobile({
          mobile: this.formA.mobile,
          phoneCode: this.phonecode,
          key: encrypted
        }).then((res) => {
          if (res.code == 0) {
            clearInterval(this.authTime);
            let num = 60;
            this.ss = num;
            this.authTime = setInterval(() => {
              --num;
              if (num >= 0) {
                this.ss = num;
                this.loading = true;
              } else {
                this.ss = "";
                clearInterval(this.ss);
                this.loading = false;
              }
            }, 1000);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      // _this.loading=false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    productChange(v) {
      this.formA.product = v;
    },
    channelChange(v) {
      console.log(v);
      this.formA.channel = v;
      this.isOther = this.formA.channel.indexOf(12);
      console.log(this.isOther);
      if (this.isOther == -1) {
        this.formA.other = "";
      }
    },
    cityChange(v) {
      // this.form.country = v
      this.formA.area = v;
      console.log(v);
      for (let item of this.cityList) {
        if (item.id == this.formA.area[0]) {
          this.province_name = item.name;
          for (let item1 of item.child) {
            if (item1.id == this.formA.area[1]) {
              this.city_name = item1.name;
              for (let item2 of item1.child) {
                // console.log(item2)
                if (item2.id == this.formA.area[2]) {
                  console.log(item2.id);
                  this.district_name = item2.name;
                }
              }
            }
          }
        }
      }
    },
    tradeChange(v) {
      console.log(v);
      this.tag = v;
      let arr = [];
      for (let i of this.tag) {
        let json = {};
        json.grandparent_id = i[0];
        json.parent_id = i[1] ? i[1] : "";
        json.id = i[2] ? i[2] : "";
        arr.push(json);
      }
      console.log(arr);
      this.trade_class = arr;
      // console.log('原始路径')
      // console.log(selectedPaths)
      // // 1. 去重原始路径（避免组件内部重复触发导致的重复数据）
      // const uniquePaths = this.removeDuplicatePaths(selectedPaths);
      // console.log('去重原始路径')
      // console.log(uniquePaths)
      // // 2. 核心联动逻辑：处理父子级勾选关系
      // const finalPaths = this.handleParentChildLink(uniquePaths);
      // console.log('最终路径')
      // console.log(finalPaths)
      // console.log('当前tag')
      // console.log(this.tag)
      // // 3. 避免循环触发change事件（仅当数据变化时更新）
      // if (JSON.stringify(this.tag) !== JSON.stringify(finalPaths)) {
      //   this.tag = finalPaths;
      //   console.log('最终的tag')
      //   console.log(this.tag)
      // }

      // // 4. 格式转换为提交格式（trade_class）
      // this.formatToTradeClass(finalPaths);
    },
    /**
     * 辅助函数：路径去重（基于路径数组的字符串表示）
     * @param {Array} paths - 原始路径数组
     * @returns {Array} 去重后的路径数组
     */
    removeDuplicatePaths(paths) {
      const pathSet = new Set();
      return paths.filter((path) => {
        const pathStr = JSON.stringify(path);
        if (!pathSet.has(pathStr)) {
          pathSet.add(pathStr);
          return true;
        }
        return false;
      });
    },

    /**
     * 核心逻辑：处理父子级联动关系
     * 规则1：勾选二级 → 自动勾选对应一级
     * 规则2：勾选一级 → 不勾选任何二级
     * 规则3：取消一级 → 取消其下所有已勾选的二级
     * @param {Array} paths - 去重后的原始路径
     * @returns {Array} 处理后的最终路径
     */
    handleParentChildLink(paths) {
      // 步骤1：收集所有“有效”的一级节点ID
      // “有效”指：要么本身被勾选（路径长度为1），要么其下有二级节点被勾选
      const validParentIds = new Set();
      
      paths.forEach((path) => {
        if (path.length === 1) {
          // 规则2：如果一级节点本身被勾选，直接加入
          validParentIds.add(path[0]);
        } else if (path.length === 2) {
          // 规则1：如果二级节点被勾选，其对应的父级ID应被视为“有效”
          validParentIds.add(path[0]);
        }
      });

      // 步骤2：过滤二级节点：仅保留“父级为有效”的二级节点
      const validPaths = paths.filter((path) => {
        if (path.length === 2) {
          // 规则3：检查其父级是否仍为“有效”（即父级本身被勾选，或有其他二级被勾选）
          // 如果父级ID不在 validParentIds 中，说明该一级节点已被取消勾选
          return validParentIds.has(path[0]);
        }
        // 一级节点和其他情况都保留
        return true;
      });

      // 步骤3：补全一级节点：确保所有二级节点的父级都已在最终列表中
      const finalPaths = [...validPaths];
      const finalPathSet = new Set(finalPaths.map((p) => JSON.stringify(p)));

      validPaths.forEach((path) => {
        if (path.length === 2) {
          const parentPath = [path[0]]; // 对应一级路径
          const parentPathStr = JSON.stringify(parentPath);
          // 若父级未在最终路径中，则添加
          if (!finalPathSet.has(parentPathStr)) {
            finalPaths.push(parentPath);
            finalPathSet.add(parentPathStr);
          }
        }
      });

      // 步骤4：排序（保证一级在前，二级在后，视觉上更直观）
      finalPaths.sort((a, b) => a.length - b.length);

      return finalPaths;
    },

    /**
     * 格式转换：将路径数组转为后端需要的 trade_class 格式
     * @param {Array} paths - 处理后的最终路径
     */
    formatToTradeClass(paths) {
      const result = [];
      const idSet = new Set(); // 避免同一ID重复添加

      paths.forEach((path) => {
        const id = path[path.length - 1]; // 当前节点ID
        if (idSet.has(id)) return; // 跳过已存在的ID

        const json = {
          grandparent_id: "", // 二级结构，祖父级为空
          parent_id: path.length === 1 ? "" : path[0], // 一级节点parent_id为空，二级为一级ID
          id: id,
        };
        result.push(json);
        idSet.add(id);
      });

      this.trade_class = result;
      console.log("最终提交数据 trade_class:", this.trade_class);
    },
    countryChange(v) {
      this.formA.country = v;
      console.log(v);
      for (let item of this.clist) {
        if (item.id == this.formA.country) {
          this.country_name = item.name_zh;
        }
      }
    },
    phoneCodeChange(v) {
      this.phonecode = v;
      console.log(this.phonecode);
      // this.form.type = v
    },
    statusChange(v) {
      console.log(v);
      this.formA.type = v;
      this.showlist = true;
    },
    save1() {
      this.$router.push({ name: "done", params: { id: 11 } });
    },
    save(formA) {
      if (this.checked) {
        this.$refs[formA].validate((valid) => {
          if (valid) {
            if (this.formA.area[0] == 0 && this.formA.country == 44) {
              this.$message.error("请选择您的地区");
            } else if (this.tag.length == 0 && this.formA.type == 2) {
              this.$message.error("请至少选择一个您所属的行业类别");
            } else {
              let channel_id = 0;
              if (this.$route.query.channel_id) {
                channel_id = this.$route.query.channel_id;
              }
              let data = {
                apply_origin: 2,
                source: 2,
                channel_id,
                id: this.customerApplyId,
                name: this.formA.name,
                phonecode: this.phonecode,
                mobile: this.formA.mobile,
                IDcard_type: this.formA.cardType,
                IDcard: this.formA.idcard,
                email: this.formA.email,
                country_id: this.formA.country,
                country_name: this.country_name,
                province_id: this.formA.area[0],
                province_name: this.province_name,
                city_id: this.formA.area[1],
                city_name: this.city_name,
                district_id: this.formA.area[2],
                district_name: this.district_name,
                address: this.formA.address,
                find_channel_key: this.formA.channel,
                other: this.formA.other,
                //消费者
                type: this.formA.type,
                sex: this.formA.sex,
                age: this.formA.age,
                product_class_key: this.formA.product,
                //专业观众
                // booth_area,
                company_name: this.formA.company_name,
                department: this.formA.department,
                job: this.formA.job,
                job_level: this.formA.level,
                trade_class: this.trade_class,
                // area:this.ipt0,
                // standard_booth_num:this.ipt1,
                // hardcover_booth_num:this.ipt2,
              };
              this.submitLoading = true;
              customerApply(data).then((res) => {
                if (res.code == 0) {
                  this.submitLoading = false;
                  this.customerApplyId = res.data.customerApplyId
                  this.apply_type = res.data.apply_type
                  if (res.data.is_reservation == 1) {
                    this.pop2 = true
                    this.getUserTime()
                  } else {
                    this.$router.push({
                      name: "done",
                      query: {
                        id: res.data.customerApplyId,
                        apply_type: res.data.apply_type,
                        mobile: this.formA.mobile,
                        email: this.formA.email,
                        channel_id: this.$route.query.channel_id
                      },
                    });
                  }
                  
                } else if (res.code == 410) {
                  this.submitLoading = false;
                  this.$alert('身份证核验异常，请确认姓名、身份证是否填写错误，如正确但仍然异常，您可稍后再试或本人持身份证原件至展会观众登记处进行现场注册”', '', {
                    showClose: false,
                    showCancelButton: false
                  })
                  .then(_ => {
                    done();
                  })
                  .catch(_ => {});
                } else {
                  this.submitLoading = false;
                  this.$message.error(res.msg);
                }
              });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.$message.error('请查看并同意隐私协议和安全须知')
      }
    },
    submit() {
      const data = { ids: this.ids, is_en: 0 }
      if (this.mobile != '') {
        data.mobile = this.formA.mobile
      }
      checkEnterTime(data).then(res => {
        if (res.code === 0) {
          this.pop2 = false
          this.$router.push({
            name: "done",
            query: {
              id: this.customerApplyId,
              apply_type: this.apply_type,
              mobile: this.formA.mobile,
              email: this.formA.email
            },
          });
        }
      })
    },
    getList() {
      customerApplySelectOption().then((res) => {
        // this.cityList = res.data
        this.productClass = res.data.productClass;
        this.findChannel = res.data.findChannel;
        this.jobLevel = res.data.jobLevel;
        this.formA.level = res.data.jobLevel[0].key
        this.cardList = res.data.IDcardType;
      });
    },
    got() {
      this.pop = true;
      this.pop1 = false;
    },
    getCity() {
      // 删除空的child
      let recursion = (datas) => {
        datas.forEach((item) => {
          if (item.child.length == 0) {
            delete item.child;
          } else {
            recursion(item.child);
          }
          item.sel = false;
          if (item.child) {
            // item.children = item.child;
            item.sel = false;
          }
        });
      };
      city().then((res) => {
        recursion(res.data);
        this.cityList = res.data;
      });
    },
    countryList() {
      countryList().then((res) => {
        this.clist = res.data;
      });
    },
    getTag() {
      // 删除空的child
      let recursion = (datas) => {
        datas.forEach((item) => {
          if (item.child.length == 0) {
            delete item.child;
          } else {
            recursion(item.child);
          }
          item.sel = false;
          if (item.child) {
            // item.children = item.child;
            item.sel = false;
          }
        });
      };
      tag().then((res) => {
        recursion(res.data);
        this.industry = res.data;
      });
    },
    goPrivacy() {
      const newpage = this.$router.resolve({
        name: 'privacy',
      })
      window.open(newpage.href, '_blank')
    },
    goSafety() {
      const newpage = this.$router.resolve({
        name: 'safety',
      })
      window.open(newpage.href, '_blank')
    }
  },
  // created() {
  //   let u = navigator.userAgent;
  //   if (u.indexOf("iPhone") > -1) {
  //     inobounce.enable();
  //   }
  // },
  // beforeDestroy() {
  //   inobounce.disable();
  // },
};
</script>



<style scoped>

.mask-box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  font-size: 28px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}

.el-dialog__header {
  padding: 0 !important;
}
.home-wrapper /deep/ .el-dialog__body {
  padding: 12px 30px 30px !important;
}
.home-wrapper {
  width: 100%;
  height: 100%;
  background: url("https://aweqn.zhiandexpo.com/awe2027pc.jpg") no-repeat;
  background-size: contain;
  padding-top: 22%;
  padding-bottom: 120px;
}
.box {
  width: 1200px;
  /* height: 820px; */
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.24);
  border-radius: 27px;
  margin: 0 auto;
  padding: 50px 40px;
  box-sizing: border-box;
  /* position: relative; */
  /* margin-top: 400px;
    margin-bottom: 200px; */
}
.exhibition {
  font-size: 16px;
  font-weight: bold;
  font-family: SourceHanSansSC, SourceHanSansSC;
  padding: 2px 8px;
  border-radius: 7px;
  background: #1C519A;
  color: #fff;
  display: inline-block;
  margin-bottom: 20px;
}
.title-box {
  border-bottom: 1px solid #303053;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #303053;
}
.msg {
  margin-bottom: 10px;
  font-size: 14px;
}
.title .lf {
  display: flex;
  align-items: flex-end;
}
.title .btn {
  width: 147px;
  /* height: 33px; */
  /* line-height: 33px; */
  background: #1C519A;
  border-color: #1C519A;
}
.txt {
  font-size: 36px;
  margin-bottom: 20px;
}
.tip {
  color: #1C519A;
  margin-bottom: 20px;
  font-size: 18px;
}
.form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-right: -10px;
}
/* .item{
    width: 30%;
  } */
.ipt {
  width: 290px;
}
.item1 {
  width: 100%;
}
.ipt1 {
  width: 100%;
}
.item2 {
  width: 46%;
}
.ipt2 {
  width: 100%;
}
.btm {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.btm-pri {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn {
  width: 300px;
  background-color: #303053;
  border-color: #303053;
}
.home-wrapper /deep/ .el-dialog__header {
  padding: 0 !important;
}
.pop .mobile .ipt {
  width: 100%;
}
.pop .code {
  margin-bottom: 30px;
}
.pop .code .ipt {
  width: 50%;
  margin-right: 10px;
}
.codebtn {
  width: 46%;
}
.popbtn {
  width: 100%;
}
.el-dialog__body .title {
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
.stitle {
  font-size: 12px;
  color: #1C519A;
  font-weight: 400;
}
.timeList {
  display: flex;
  flex-wrap: wrap;
}
.timeList .item {
  width: 118px;
  /* margin-bottom: 20px;
  margin-right: 24px; */
  margin: 20px 24px 20px 0;
}
.time {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
}
.checkBox {
  width: 118px;
  height: 204px;
}
.checkItem {
  width: 118px;
  height: 82px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #999;
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}

.checked {
  border: 1px solid #1C519A;
  color: #333333;
}
.item-top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-btm {
  color: #1C519A;
}
.code {
  font-weight: 500;
  margin-right: 4px;
}
.el-dialog__body .btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}
.submit {
  cursor: pointer;
  width: 190px;
  height: 32px;
  background: #1C519A;
  border-radius: 17px;
  border: 1px solid #1C519A;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #fff;
}
.box /deep/ .el-button--primary.is-plain {
  color: #1C519A;
  background-color: rgba(16,68,147, 0.24);
  border-color: rgba(16,68,147, 0.6);
}

.box /deep/ .el-button--primary {
  background-color: #1C519A;
  border-color: #1C519A;
}
</style>



// WEBPACK FOOTER //
// src/views/home/form.vue